module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"anonymous":"Anonymous"},"fr":{"anonymous":"Anonyme"}}')
  delete Component.options._Ctor
}
